<div class="dashboard-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            DANH SÁCH NHÂN VIÊN
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="messError">
                        <span>{{messError}}</span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                            <div class="col-sm-11 d-flex flex-column">
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.employer_name.label"
                                                :id="dataSearch.employer_name.id"
                                                :placeholder="dataSearch.employer_name.placeholder"
                                                :value-default="dataSearch.employer_name.value"
                                                @inputValue="onChange($event, dataSearch.employer_name.id)"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.employer_email.label"
                                                :id="dataSearch.employer_email.id"
                                                :placeholder="dataSearch.employer_email.placeholder"
                                                :value-default="dataSearch.employer_email.value"
                                                @inputValue="onChange($event, dataSearch.employer_email.id)"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.employer_phone.label"
                                                :id="dataSearch.employer_phone.id"
                                                :placeholder="dataSearch.employer_phone.placeholder"
                                                :value-default="dataSearch.employer_phone.value"
                                                @inputValue="onChange($event, dataSearch.employer_phone.id)"
                                        ></InputTextNormal>
                                    </div>
                                </div>

                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <SelectNormal
                                                :label="dataSearch.employer_role.label"
                                                :id="dataSearch.employer_role.id"
                                                :placeholder="dataSearch.employer_role.placeholder"
                                                :value-default="dataSearch.employer_role.value"
                                                :options="dataSearch.employer_role.options"
                                                @inputValue="onChange($event, dataSearch.employer_role.id)"
                                        ></SelectNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <SelectNormal
                                                :label="dataSearch.employer_store_id.label"
                                                :id="dataSearch.employer_store_id.id"
                                                :placeholder="dataSearch.employer_store_id.placeholder"
                                                :value-default="dataSearch.employer_store_id.value"
                                                :options="dataSearch.employer_store_id.options"
                                                @inputValue="onChange($event, dataSearch.employer_store_id.id)"
                                        ></SelectNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-1 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSearch" @click="searchEmployers"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                    <div class="btn-invite-employer">
                        <ButtonAddComponent :label="labelButtonInvite" @click="redirectToInvite"></ButtonAddComponent>
                    </div>
                    <div class="col-sm-12">
                        <div class="col-sm-12 d-flex justify-content-between mt-4">
                            <div class="action d-flex align-items-center gap-3">
                                <div class="total">
                                    {{ CommonText.TOTAL_RECORD(listEmployers.length, paginate.itemCount) }}
                                </div>
                                <div class="dropdown-action">
                                    <SelectCustom
                                            :label="selectAction.label"
                                            :id="selectAction.id"
                                            :placeholder="selectAction.placeholder"
                                            :value-default="selectAction.value"
                                            :required="selectAction.required"
                                            :options="selectAction.options"
                                            @action="actionSelect($event)"
                                    ></SelectCustom>
                                </div>
                            </div>
                            <div class="action-left d-flex align-items-center gap-3">
                                <div class="dropdown-action">
                                    <SelectCustom
                                            :label="selectLimitPage.label"
                                            :id="selectLimitPage.id"
                                            :placeholder="selectLimitPage.placeholder"
                                            :value-default="selectLimitPage.value"
                                            :required="selectLimitPage.required"
                                            :options="selectLimitPage.options"
                                            @action="actionLimitPage($event)"
                                    ></SelectCustom>
                                </div>
                            </div>
                        </div>
                        <div class="list-employers-component">
                            <table class="table table-bordered">
                                <thead>
                                <tr>
                                    <th scope="col" style="width: 2%;"><InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)" :checked="checkAll"></InputCheckboxOne></th>
                                    <th scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="listEmployers.length > 0" v-for="(employer, key) in listEmployers" :key="employer.id">
                                    <td><InputCheckboxOne :id="employer.id" :value-default="checkItems[employer.id]" @inputValue="onChangeSelectItem($event, employer.id)" :checked="checkItems[employer.id]"></InputCheckboxOne></td>
                                    <td>{{employer.user_name ?? ''}}</td>
                                    <td>{{employer.role?.name}}</td>
                                    <td>{{employer.mail_address}}</td>
                                    <td>{{employer.userInfo?.user_phone}}</td>
                                    <td>{{ [2,3,4,5].includes(employer.role?.id) ? '' : employer.store?.name }}</td>
                                </tr>
                                <tr v-else>
                                    <td colspan="6" class="text-center">Không có dữ lệu được tìm thấy!</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <PaginateComponent v-if="listEmployers.length > 0 && paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
                </div>
            </div>
        </div>
    </div>
</div>

<LoadingComponent v-if="isLoading"></LoadingComponent>
